import { get } from 'lodash';
import { NOTIFICATIONS_APP_ID } from '../../constants/applications';
import { SET_CURRENT_USER } from '../../actions/set-current-user';
import { FETCH_NOTIFICATIONS_SUCCESS } from '../../actions/fetch-notifications';
import { NEW_NOTIFICATION } from '../../actions/user-socket';
import { ENABLE_NOTIFICATION_COUNT_CHANGE } from '../../actions/enable-notifications-count-change';
import { SET_NOTIFICATION_COUNT } from '../../actions/set-notification-count';

const getNotificationsCountFromUser = user => get(user, `counters.${NOTIFICATIONS_APP_ID}.notificationsCount`, 0);

export default (state = { count: 0, isUpdateAllowed: true }, action = {}) => {
  switch (action.type) {
    case ENABLE_NOTIFICATION_COUNT_CHANGE:
      return { ...state, isUpdateAllowed: action.payload };
    case SET_CURRENT_USER:
      return state.isUpdateAllowed ? { ...state, count: getNotificationsCountFromUser(action.payload) } : state;
    case FETCH_NOTIFICATIONS_SUCCESS:
      return { ...state, count: 0 };
    case NEW_NOTIFICATION:
      return state.isUpdateAllowed ? { ...state, count: state.count + 1 } : state;
    case SET_NOTIFICATION_COUNT:
      return {
        ...state,
        count: action.payload,
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./app/reducers/notifications/metadata.js